import { render, staticRenderFns } from "./WaveChart.vue?vue&type=template&id=ed17f510&"
import script from "./WaveChart.vue?vue&type=script&lang=js&"
export * from "./WaveChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports